import React from 'react'
import PDIComponent from '../pdi/PDIComponent'

export const SevkeHazirlama = () => {
    return <PDIComponent
        role_name={"sevke_hazirlama_write"}
        title="Sevke Hazırlama" radioItems={["Sevke Hazırlama", "Hasar Bildir"]} minCharacter={17} defaultRadio="Sevke Hazırlama" showSwitch={false} api="/prepareForShipping" modalArea="Sevke Hazırlama" />
}
